import { render, staticRenderFns } from "./add-account.vue?vue&type=template&id=526b6ac9&scoped=true"
import script from "./add-account.vue?vue&type=script&lang=js"
export * from "./add-account.vue?vue&type=script&lang=js"
import style0 from "./add-account.vue?vue&type=style&index=0&id=526b6ac9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526b6ac9",
  null
  
)

export default component.exports